import Phaser from 'phaser';

export function unlockAudioContext(scene: Phaser.Scene): void {
  const soundManager = scene.sound;
  if (!('context' in soundManager)) return;

  const ctx = (soundManager as Phaser.Sound.WebAudioSoundManager).context;
  if (!ctx) return;

  if (ctx.state === 'suspended') {
    void ctx.resume();
  }

  try {
    const buffer = ctx.createBuffer(1, 1, 22050);
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    source.connect(ctx.destination);
    source.start(0);
  } catch {
    // Игнорируем — на не-WebAudio платформах createBuffer может бросить.
  }
}
